<template>
  <div class="profile-layout">
    <main-navbar></main-navbar>
    <div class="wrapper" :class="[{ 'nav-open': $sidebar.showSidebar }]" @click="closeArea">
      <notifications></notifications>
      <side-bar
        :mini="isMini"
        :active-color="sidebarBackground"
        :background-image="sidebarBackgroundImage"
        :data-background-color="sidebarBackgroundColor"
      >
        <template slot="links">
          <!-- Shared app nav — same grouped menu (Research / Analyze / My Data) the rest
               of the app renders via DashboardLayout. This layout used to hardcode its own
               flat copy (extra Market/Franchise items, no groupings), so the sidebar visibly
               changed when navigating in/out of the prospect tool. -->
          <sidebar-links></sidebar-links>
        </template>
      </side-bar>
      <app-side-bar
        v-if="isProspectSearch"
        :mini="true"
        :active-color="sidebarBackground"
        :background-image="sidebarBackgroundImage"
        :data-background-color="sidebarBackgroundColor"
        class="prospect_menu"
      >
        <mobile-menu></mobile-menu>
        <div class="search_panel">
          <h3>Search Prospect</h3>
          <h3>Filter</h3>
          <ul class="filter_list">
            <li
              id="li-industry"
              @click="showExtendArea($event)"
              v-click-outside-component="closeArea"
            >
              <md-icon>business_center</md-icon>Industry
              <div class="dropdown_area">
                <div class="header">
                  <h4>Industry</h4>
                  <md-button class="done_btn" @click="closeArea()">Done</md-button>
                </div>
                <div class="new-profile" @click="selectArea($event)">
                  <industry-select />
                </div>
              </div>
            </li>
            <div v-show="$store.getters.industry != null">
              <li :class="$store.getters.industry == null ? 'disabled-item' : ''" @click="showExtendArea($event)">
                <md-icon>ballot</md-icon>Contacts
                <div class="dropdown_area ">
                  <div class="header">
                    <h4>Contacts</h4>
                    <md-button class="done_btn" @click="closeArea()">Done</md-button>
                  </div>
                  <div class="drop_content">
                    <div class="checklistWpr">
                      <ul class="checklist">
                        <li v-for="item in optionsContacts" :key="item.value">
                          
                          <md-checkbox :id=item.value v-model="contacts[item.value]" />
                          <label :for=item.value>{{item.text}}</label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </li>
              <li :class="$store.getters.industry == null ? 'disabled-item' : ''" @click="showExtendArea($event)">
                <md-icon>place</md-icon>Market Area
                <div class="dropdown_area">
                  <div class="header">
                    <h4>Market Area</h4>
                    <md-button class="done_btn" @click="closeArea()">Done</md-button>
                  </div>
                  <div class="new-profile" @click="selectArea($event)">
                    <area-select />
                  </div>
                </div>
              </li>
              <li :class="$store.getters.industry == null ? 'disabled-item' : ''" @click="showExtendArea($event)">
                <md-icon>analytics</md-icon>Estimated Revenue
                <div class="dropdown_area">
                  <div class="header">
                    <h4>Estimated Revenue</h4>
                    <md-button class="done_btn" @click="closeArea()">Done</md-button>
                  </div>
                  <div class="revenue">
                    <div class="field_wpr">
                      <label for="label-fr">From</label>
                      <select id="label-fr" v-model="fromRevenueModel">
                        <option :value="1" :key="1">All Sales</option>
                        <option
                          v-for="item in optionsRangeFrom"
                          :value="item.value"
                          :key="item.value"
                        >{{ item.text }}</option>
                      </select>
                    </div>
                    <div class="field_wpr">
                      <label for="label-to">To</label>
                      <select id="label-to" v-model="toRevenueModel">
                        <option :value="1" :key="1">All Sales</option>
                        <option
                          v-for="item in optionsRangeTo"
                          :value="item.value"
                          :key="item.value"
                        >{{ item.text }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </li>
              <li :class="$store.getters.industry == null ? 'disabled-item' : ''" @click="showExtendArea($event)">
                <md-icon>poll</md-icon>Estimated Value
                <div class="dropdown_area">
                  <div class="header">
                    <h4>Estimated Value</h4>
                    <md-button class="done_btn" @click="closeArea()">Done</md-button>
                  </div>
                  <div class="revenue">
                    <div class="field_wpr">
                      <label for="label-fr-all">From</label>
                      <select id="label-fr-all" v-model="fromValueModel">
                        <option :value="1" :key="1">All Values</option>
                        <option
                          v-for="item in optionsRangeFrom"
                          :value="item.value"
                          :key="item.value"
                        >{{ item.text }}</option>
                      </select>
                    </div>
                    <div class="field_wpr">
                      <label for="label-to-all" >To</label>
                      <select id="label-to-all"  v-model="toValueModel">
                        <option :value="1" :key="1">All Values</option>
                        <option
                          v-for="item in optionsRangeTo"
                          :value="item.value"
                          :key="item.value"
                        >{{ item.text }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </li>
              <li :class="$store.getters.industry == null ? 'disabled-item' : ''" @click="showExtendArea($event)">
                <md-icon>hotel_class</md-icon>Years in Business
                <div class="dropdown_area">
                  <div class="header">
                    <h4>Years in Business</h4>
                    <md-button class="done_btn" @click="closeArea()">Done</md-button>
                  </div>
                  <div class="range_bar">
                    <div class="revenue">
                      <div class="field_wpr">
                        <label for="label-from">From</label>
                        <select id="label-from" v-model="fromYearModel">
                          <option :value="-1" :key="-1">All Values</option>
                          <option v-for="item in optionsYears" :value="item" :key="item">{{ item }}</option>
                        </select>
                      </div>

                      <div class="field_wpr">
                        <label for="label-to-values">To</label>
                        <select id="label-to-values" v-model="toYearModel">
                          <option :value="-1" :key="-1">All Values</option>
                          <option v-for="item in optionsYears" :value="item" :key="item">{{ item }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li :class="$store.getters.industry == null ? 'disabled-item' : ''" @click="showExtendArea($event)">
                <md-icon>groups</md-icon>Employee Count
                <div class="dropdown_area">
                  <div class="header">
                    <h4>Employee Count</h4>
                    <md-button class="done_btn" @click="closeArea()">Done</md-button>
                  </div>
                  <div class="range_bar">
                    <label class="title-dark-blue-color" for="select-employee">Employee Count</label>
                    <select id="select-employee" v-model="employeeCount">
                      <option
                        v-for="item in optionsEmployeeCount"
                        :value="item.value"
                        :key="item.value"
                      >{{ item.text }}</option>
                    </select>
                  </div>
                </div>
              </li>
              <li :class="$store.getters.industry == null ? 'disabled-item' : ''" @click="showExtendArea($event)">
                <md-icon>storefront</md-icon>Franchise
                <div class="dropdown_area">
                  <div class="header">
                    <h4>Franchise</h4>
                    <md-button class="done_btn" @click="closeArea()">Done</md-button>
                  </div>
                  <div class="franchise">
                    <md-radio v-model="radioFranchise" :value="true">Yes</md-radio>
                    <md-radio v-model="radioFranchise" :value="false">No</md-radio>
                  </div>
                </div>
              </li>
              <li :class="$store.getters.industry == null ? 'disabled-item' : ''" @click="showExtendArea($event)">
                <md-icon>redeem</md-icon>Web Presense
                <div class="dropdown_area">
                  <div class="header">
                    <h4>Web Presense</h4>
                    <md-button class="done_btn" @click="closeArea()">Done</md-button>
                  </div>
                  <div class="franchise">
                    <md-radio v-model="radioWebPresense" :value="true">Yes</md-radio>
                    <md-radio v-model="radioWebPresense" :value="false">No</md-radio>
                  </div>
                </div>
              </li>
              <li :class="$store.getters.industry == null ? 'disabled-item' : ''" @click="showExtendArea($event)">
                <md-icon>campaign</md-icon>Social Presense
                <div class="dropdown_area">
                  <div class="header">
                    <h4>Social Presense</h4>
                    <md-button class="done_btn" @click="closeArea()">Done</md-button>
                  </div>
                  <div class="franchise">
                    <md-radio v-model="radioSocialPresense" :value="true">Yes</md-radio>
                    <md-radio v-model="radioSocialPresense" :value="false">No</md-radio>
                  </div>
                </div>
              </li>
            </div>
          </ul>
          <md-button id="clear-search-prospect" class="clear_btn" @click="clearSearchProspect()">
            <md-icon>close</md-icon>Clear Search Prospect
          </md-button>
        </div>
      </app-side-bar>
      <div class="main-panel">
        <div class="content">
          <slot></slot>
        </div>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith('Win');
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar('sidebar');
    initScrollbar('sidebar-wrapper');
    initScrollbar('main-panel');

    docClasses.add('perfect-scrollbar-on');
  } else {
    docClasses.add('perfect-scrollbar-off');
  }
}

function initSidebar() {
  document.body.classList.toggle('sidebar-mini');
}

import MainNavbar from './MainNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import MobileMenu from './Extra/MobileMenu.vue';
import SidebarLinks from './SidebarLinks.vue';
import { RangeSlider } from '@/components';
import axios from 'axios';
import IndustrySelect from '@/pages/Bizminer/Search/_partials/IndustrySelect';
import AreaSelect from '@/pages/Bizminer/Search/_partials/AreaSelect';
import { mapState } from 'vuex';

export default {
  components: {
    MainNavbar,
    ContentFooter,
    MobileMenu,
    SidebarLinks,
    //RangeSlider,
    IndustrySelect,
    AreaSelect,
  },
  props: ['mini', 'prospectSearch', 'dataFilter'],
  data() {
    return {
      isMini: this.mini,
      isProspectSearch: this.prospectSearch,
      isClearSearch: false,
      sidebarBackgroundColor: 'grey',
      sidebarBackground: 'green',
      sidebarBackgroundImage:
        process.env.VUE_APP_BASE_URL + '/img/sidebar-2.jpg',
      sidebarMini: true,
      sidebarImg: true,
      image: process.env.VUE_APP_BASE_URL + '/img/laravel-vue.svg',
      roles: [],
      expandNews: false,
      expandSingle: false,
      loading: true,
      checked: [],
      //profileId: 0,
      dataFilterSaved: this.dataFilter,

      /**
       * Models filters
       */
      years_in_business: this.$store.getters.psYearsInBusiness,

      /**
       * Model filters Radio Buttons
       */
      radioSocialPresense: this.$store.getters.psRadioSocialPresense,
      radioWebPresense: this.$store.getters.psRadioWebPresense,
      radioFranchise: this.$store.getters.psRadioFranchise,

      /**
       * Arrays Estimated Revenue, Estimated Value From/To, EmployeeCount and Contacts
       */
      optionsRangeFrom: [
        {
          value: '2',
          text: '$1'
        },
        {
          value: '3',
          text: '$500k'
        },
        {
          value: '4',
          text: '1m'
        },
        {
          value: '5',
          text: '$2m'
        },
        {
          value: '6',
          text: '$3m'
        },
        {
          value: '7',
          text: '$4m'
        },
        {
          value: '8',
          text: '$5m'
        },
        {
          value: '9',
          text: '$7.5m'
        },
        {
          value: '10',
          text: '$10m'
        },
        {
          value: '11',
          text: '$15m'
        },
        {
          value: '12',
          text: '$20m'
        },
        {
          value: '15',
          text: '$40m'
        },
      ],
      optionsRangeTo: [
        {
          value: '2',
          text: '$499k'
        },
        {
          value: '3',
          text: '$999k'
        },
        {
          value: '4',
          text: '$1.99m'
        },
        {
          value: '5',
          text: '$2.99m'
        },
        {
          value: '6',
          text: '$3.99m'
        },
        {
          value: '7',
          text: '$4.99m'
        },
        {
          value: '8',
          text: '$7.49m'
        },
        {
          value: '9',
          text: '$9.99m'
        },
        {
          value: '10',
          text: '$14.99m'
        },
        {
          value: '11',
          text: '$19.99m'
        },
        {
          value: '12',
          text: '$24.99m'
        },
        {
          value: '15',
          text: '$49.99m'
        },
      ],
      optionsEmployeeCount: [
        {
          text: '1-24 Employees (small)',
          value: '1-24',
        },
        {
          text: '25-99 Employees (medium)',
          value: '25-99',
        },
        {
          text: '100+ Employees (large)',
          value: '100+',
        },
      ],
      optionsContacts: [
        {
          value: 'all_records',
          text: 'All Records'
        },
        {
          value: 'contact_street_addr',
          text: 'Records with a street address'
        },
        {
          value: 'contact_name',
          text: 'Records with a contact name'
        },
        {
          value: 'contact_phone',
          text: 'Records with a contact phone'
        },
      ],

      optionsYears: [
        0, 1, 2, 3, 4, 5, 8, 10, 15, 20, 25, 30, 40, 50, 75, 100
      ],
      /**
       * Models Filters Estimated Revenue and Estimated Value From/To
       */
      fromRevenueModel: this.$store.getters.psFromRevenueModel,
      toRevenueModel: this.$store.getters.psToRevenueModel,
      fromValueModel: this.$store.getters.psFromValueModel,
      toValueModel: this.$store.getters.psToValueModel,

      fromYearModel: this.$store.getters.psFromYearModel,
      toYearModel: this.$store.getters.psToYearModel,

      employeeCount: this.$store.getters.psEmployeeCount,

      /**
       * Model Contacts
       */
      contacts: {
        all_records: this.$store.getters.psAllRecords,
        contact_street_addr: this.$store.getters.psContactStreetAddr,
        contact_name: this.$store.getters.psContactName,
        contact_phone: this.$store.getters.psContactPhone,
      },

      allRecords: false,
      isFiltering: false,

    };
  },
  computed: {
    ...mapState({
      auth_user: (state) => state.user,
      defaultScreen: (state) => state?.user?.user?.preferences?.defaultScreen,
    }),
    industry() {
      return this.$store.getters.industry;
    },
    marketArea() {
      return this.$store.getters.marketArea;
    },
    profileId() {
      return this.$store.getters.psId;
    }
  },
  mounted() {
    // Only auto-run the CLASSIC prospect load when this layout is actually hosting the
    // classic filter panel (prospectSearch=true). The Beta ProspectPage reuses this layout
    // purely for chrome (prospectSearch=false) on the same 'ProspectSearch' route, and must
    // NOT trigger classic industry/filter fetches. (SearchList uses a different route name.)
    if (this.$route.name === "ProspectSearch" && this.isProspectSearch) {
      this.triggerIndustry();
      this.filter();
    }
  },
  methods: {
    showExtendArea: function (e) {
      e.stopPropagation();
      let el = e.currentTarget;
      let pos = el.offsetTop;
      let all_el = document.querySelectorAll('.filter_list li');
      let dropDown = document.querySelectorAll('.dropdown_area');
      let scrl = document.querySelector('.search_panel').scrollTop;
      let elem = el.querySelector('.dropdown_area');
      let screen = window.innerHeight - 75;
      elem.style.top = 'auto';
      if (el.classList.contains('show')) {
        el.classList.remove('show');
      } else {
        all_el.forEach(function (x) {
          x.classList.remove('show');
        })
        el.classList.add('show');
      }
      dropDown.forEach(function (x) {
        x.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      })
      if (screen < (elem.offsetHeight + pos)) {
        elem.style.bottom = 10 + 'px';
        elem.style.top = 'auto';
      }
      else {
        elem.style.top = (pos + 75) - scrl + 'px';
        elem.style.bottom = 'auto';
      }

      var favSelects = document.querySelectorAll('.favourite_list');
      [].forEach.call(favSelects, function (el) {
        el.classList.remove('open');
      });
    },
    selectArea: function (e) {
      let parentDiv = document.querySelectorAll('.custom-step-pro');
      let deactiveClass = document.querySelectorAll('.step-progress__step');
      let favoriteDropdown = document.querySelectorAll('.favourite_list');
      deactiveClass.forEach(function (el) {
        el.classList.remove('open');
      });
      favoriteDropdown.forEach(function (el) {
        el.classList.remove('open');
      });
      parentDiv.forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      });
    },
    getMyData: async function () {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      let myDataId = this.$route.query['data-id'];
      this.loaded = false;

      let params = {
        session_id: currentSession,
        my_data_id: myDataId,
      };

      await this.$store.dispatch('myData/get', params).then((res) => {
        this.myData = res.data.my_data;
        this.years = res.data.years;
        this.checkAvailability();
        this.loaded = true;
      });
    },
    closeArea: function () {
      let all_el = document.querySelectorAll('.filter_list li');
      all_el.forEach(function (x) {
        x.classList.remove('show');
      })
    },
    drop: function (el) {
      let ev = el.currentTarget.parentNode;
      if (ev.classList.contains('active')) {
        ev.classList.remove('active');
      } else {
        ev.classList.add('active');
      }
    },

    sendDataFatherComponent: function (totalResultsCountAux, idAux, priceAux) {
      this.$emit('get-data', { total: totalResultsCountAux, id: idAux, price: priceAux, industry: this.industry })
    },
    sendLoadStatusFatherComponent: function (isFilter, isLoading) {
      this.$emit('load-data', { isFilter: isFilter, isLoading: isLoading, industry: this.industry })
    },
    clearSearchProspect: function () {
      this.isClearSearch = true;

      this.contacts.contact_name = null,
        this.contacts.contact_phone = null,
        this.contacts.contact_street_addr = null,
        this.contacts.all_records = null,
        this.fromValueModel = null,
        this.toValueModel = null,
        this.fromRevenueModel = null,
        this.toRevenueModel = null,
        this.employeeCount = null,
        this.fromYearModel = null,
        this.toYearModel = null,
        this.radioSocialPresense = null;
      this.radioWebPresense = null;
      this.radioFranchise = null;
      this.$store.commit('SET_MARKET_AREA', null);
      this.$store.commit('SET_INDUSTRY', null);
      this.$store.commit('PS_SET_ID', null);
      this.sendLoadStatusFatherComponent(false, false);
      this.filter();
    },
    clearAll: async function () {
      this.$store.commit('SET_INDUSTRY', null);
      this.$store.commit('SET_MARKET_AREA', null);
    },
    getData: function (name) {
      if (name) {
        return name.split('[')[1].split(']')[0];
      }
    },
    checkAvailability: async function () {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      if (this.industry != null && this.marketArea != null) {
        this.operations = 'N/A';
        this.isDisabled = true;
        this.loading = true;

        let resZips = '0';
        let resArea = 0;
        let resMap_center = '0';
        let resMap_center_zip = '0';
        let resRadius = '0';

        await axios
          .post(
            process.env.VUE_APP_API_BASE_URL + '/user/search_profiles/company',
            {},
            {
              params: {
                session_id: currentSession,
                profile_id: this.profileId ?? 0,
                type: 'company',
              },
            }
          )
          .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
              this.$store.commit('SET_ERROR_BIT', true);
              this.$store.commit(
                'SET_ERROR_INFO',
                '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/search_profiles/company" <br>`
              );
              throw new Error(
                '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
              );
            }
            const {
              id,
              area,
              zips,
              map_center,
              map_center_zip,
              radius,
            } = res.data;
            if (this.profileId == 0 || this.profileId == null) {
              this.$store.commit('PS_SET_ID', id);
            }
            //this.profileId = id;
            resZips = zips;
            resArea = area;
            resMap_center = map_center;
            resMap_center_zip = map_center_zip;
            resRadius = radius;
          });
        await axios
          .get(process.env.VUE_APP_API_BASE_URL + '/info/IMR_available', {
            params: {
              industry: this.getData(this.industry),
              area: resArea,
              zips: resZips,
              map_center: resMap_center,
              map_center_zip: resMap_center_zip,
              radius: resRadius,
            },
          })
          .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
              this.$store.commit('SET_ERROR_BIT', true);
              this.$store.commit(
                'SET_ERROR_INFO',
                '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/IMR_available" <br>`
              );
              throw new Error(
                '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
              );
            }
            const { data } = res.data;
            if (data != 0) {
              this.operations = data[0];
              this.checkAccess();
            } else {
              this.operations = 'N/A';
              this.isDisabled = true;
              this.loading = false;
            }
          });
      } else {
        this.isDisabled = true;
        this.operations = 'N/A';
      }
    },
    filter: async function (materialize) {
      // Industry is the required first filter (see the v-show gating the rest of the
      // filter list below) -- without it this hits the backend's unfiltered "all US
      // companies" query path, which has no LIMIT and never returns. Guard here since
      // mounted() and clearSearchProspect() both call filter() before industry is set.
      if (!this.industry) { return; }
      // Live filter changes only need the count (countOnly) -- the backend then skips
      // fetching/storing the full company list. `materialize` is passed by the Access
      // List flow, which needs the full list stored server-side for the purchase.
      this.isFiltering = true;
      this.sendLoadStatusFatherComponent(true, true);
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      let yearsInBusiness = "-1";
      let from = -1;
      let to = -1;
      if (this.fromYearModel !== null && this.fromYearModel !== undefined)
        from = this.fromYearModel;
      if (this.toYearModel !== null && this.toYearModel !== undefined)
        to = this.toYearModel;

      if (from > to) {
        let temp = to;
        to = from;
        from = temp;
      }

      if (from !== -1 && to !== -1) {
        yearsInBusiness = `${from}-${to}`;
      }
      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/search_lists/company',
          {},
          {
            params: {
              /**
               * Required parameters:
               */
              type: 'company',
              session_id: currentSession,
              profile_id: this.profileId ?? 0,
              industry: this.getData(this.industry),
              countOnly: materialize ? undefined : 1,

              /**
               * Optional Parameteres
               */
              area: this.getData(this.marketArea),
              zips:this.marketArea && this.marketArea.includes('zips')?this.marketArea.split('[')[0]:null,
              value_from: this.fromValueModel,
              value_to: this.toValueModel,
              sales_from: this.fromRevenueModel,
              sales_to: this.toRevenueModel,
              contact_street_addr: this.contacts.contact_street_addr,
              contact_name: this.contacts.contact_name,
              contact_phone: this.contacts.contact_phone,
              years_in_business: yearsInBusiness,
              employee_count: this.employeeCount,
              franchise: this.checkRadioButton(this.radioFranchise),
              web_presence: this.checkRadioButton(this.radioWebPresense),
              social_presence: this.checkRadioButton(this.radioSocialPresense),
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/industries" <br>`
            );

            throw new Error(
              '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode
            );
          }
          else {
            if (this.profileId == 0 || this.profileId == null) {
              this.$store.commit('PS_SET_ID', res.data.id);
            }
            // SearchList (the Access List page) renders these; the backend returns them on
            // every GetCompanyList response but nothing stored them before, which left the
            // credits table blank and the "Insufficient credits" check comparing against null.
            if (res.data.credits) {
              this.$store.commit('PS_SET_CREDITS_AVAILABLE', res.data.credits.available);
              this.$store.commit('PS_SET_CREDITS_TOTAL', res.data.credits.total);
              this.$store.commit('PS_SET_CREDITS_USED', res.data.credits.used);
            }
            this.isFiltering = false;
            this.allRecords = false;
            this.isClearSearch = false;

            //this.profileId = res.data.id;
            this.sendLoadStatusFatherComponent(true, false);
            this.sendDataFatherComponent(res.data.count, this.profileId, res.data.price);
          }
        });
    },
    triggerIndustry: function () {
      let elem = document.getElementById('li-industry');
      elem.click();
    },
    checkRadioButton: function (value) {
      if (value)
        return 1;
      else if (value === false)
        return 0;

      return null;
    },
    canUpdateFilters: function (newVal, oldVal, currentFilter = true) {

      if (newVal !== oldVal && !this.isClearSearch && !this.isFiltering)
        return true;

      return false;
    }
  },
  watch: {
    dataFilter(newVal, oldVal) {

      if (newVal != null) {
        this.sendLoadStatusFatherComponent(true, true);
        this.radioFranchise = this.dataFilter.franchise != "-1" ? Boolean(parseInt(this.dataFilter.franchise)) : null;
        this.radioWebPresense = this.dataFilter.web_presence != "-1" ? Boolean(parseInt(this.dataFilter.web_presence)) : null;
        this.radioSocialPresense = this.dataFilter.social_presence != "-1" ? Boolean(parseInt(this.dataFilter.social_presence)) : null;
        this.fromYearModel = this.dataFilter.years_in_business != "-1" ? this.dataFilter.years_in_business.split("-")[0] : null;
        this.toYearModel = this.dataFilter.years_in_business != "-1" ? this.dataFilter.years_in_business.split("-")[1] : null;
        this.fromRevenueModel = this.dataFilter.sales_from != "0" ? this.dataFilter.sales_from : null;
        this.toRevenueModel = this.dataFilter.sales_to != "0" ? this.dataFilter.sales_to : null;
        this.fromValueModel = this.dataFilter.value_from != "0" ? this.dataFilter.value_from : null;
        this.toValueModel = this.dataFilter.value_to != "0" ? this.dataFilter.value_to : null;
        this.contacts.contact_street_addr = this.dataFilter.contact_street_addr != "-1" ? Boolean(this.dataFilter.contact_street_addr) : null;
        this.contacts.contact_name = this.dataFilter.contact_name != "-1" ? Boolean(this.dataFilter.contact_name) : null;
        this.contacts.contact_phone = this.dataFilter.contact_phone != "-1" ? Boolean(this.dataFilter.contact_phone) : null;
        this.employeeCount = this.dataFilter.employee_count != "-1" ? this.dataFilter.employee_count : null;

      }
    },
    fromRevenueModel(newVal, oldVal) {
      if (this.canUpdateFilters(newVal, oldVal, this.toRevenueModel)) {
        this.$store.commit('PS_SET_FROM_REVENUE_MODEL', newVal);
        this.filter();
      }
    },
    toRevenueModel(newVal, oldVal) {
      if (this.canUpdateFilters(newVal, oldVal, this.fromRevenueModel)) {
        this.$store.commit('PS_SET_TO_REVENUE_MODEL', newVal);
        this.filter();
      }
    },
    fromValueModel(newVal, oldVal) {
      if (this.canUpdateFilters(newVal, oldVal, this.toValueModel)) {
        this.$store.commit('PS_SET_FROM_VALUE_MODEL', newVal);
        this.filter();
      }
    },
    fromYearModel(newVal, oldVal) {
      if (this.canUpdateFilters(newVal, oldVal, this.toYearModel)) {
        this.$store.commit('PS_SET_FROM_YEAR_MODEL', newVal);
        this.filter();
      }
    },
    toYearModel(newVal, oldVal) {
      if (this.canUpdateFilters(newVal, oldVal, this.fromYearModel)) {
        this.$store.commit('PS_SET_TO_YEAR_MODEL', newVal);
        this.filter();
      }
    },
    toValueModel(newVal, oldVal) {
      if (this.canUpdateFilters(newVal, oldVal, this.fromValueModel)) {
        this.$store.commit('PS_SET_TO_VALUE_MODEL', newVal);
        this.filter();
      }
    },
    radioSocialPresense(newVal, oldVal) {
      if (this.canUpdateFilters(newVal, oldVal)) {
        this.$store.commit('PS_SET_RADIO_SOCIAL_PRESENSE', newVal);
        this.filter();
      }
    },
    radioWebPresense(newVal, oldVal) {
      if (this.canUpdateFilters(newVal, oldVal)) {
        this.$store.commit('PS_SET_RADIO_WEB_PRESENSE', newVal);
        this.filter();
      }
    },
    radioFranchise(newVal, oldVal) {
      if (this.canUpdateFilters(newVal, oldVal)) {
        this.$store.commit('PS_SET_RADIO_FRANCHISE', newVal);
        this.filter();
      }
    },
    employeeCount(newVal, oldVal) {
      if (this.canUpdateFilters(newVal, oldVal)) {
        this.$store.commit('PS_SET_EMPLOYEE_COUNT', newVal);
        this.filter();
      }
    },
    years_in_business(newVal, oldVal) {
      if (this.canUpdateFilters(newVal, oldVal)) {
        this.$store.commit('PS_SET_YEARS_IN_BUSINESS', newVal);
        this.filter();
      }
    },
    marketArea(newVal, oldVal) {
        this.filter();
    },
    industry(newVal, oldVal) {
      if (this.canUpdateFilters(newVal, oldVal))
        this.filter();
    },
    "contacts.all_records"(newVal, oldVal) {
      this.allRecords = true;
      if (newVal) {
        this.contacts.contact_street_addr = true;
        this.contacts.contact_name = true;
        this.contacts.contact_phone = true;
      }
      else {
        this.contacts.contact_street_addr = false;
        this.contacts.contact_name = false;
        this.contacts.contact_phone = false;
      }
      this.filter()
      this.$store.commit('PS_SET_CONTACT_STREET_ADDR', this.contacts.contact_street_addr);
      this.$store.commit('PS_SET_CONTACT_NAME', this.contacts.contact_name);
      this.$store.commit('PS_SET_CONTACT_PHONE', this.contacts.contact_phone);

    },
    "contacts.contact_street_addr"(newVal, oldVal) {
      if (this.canUpdateFilters(newVal, oldVal, !this.allRecords)) {
        this.$store.commit('PS_SET_CONTACT_STREET_ADDR', newVal);
        this.filter();
      }

    },
    "contacts.contact_name"(newVal, oldVal) {
      if (this.canUpdateFilters(newVal, oldVal, !this.allRecords)) {
        this.$store.commit('PS_SET_CONTACT_NAME', newVal);
        this.filter();
      }
    },
    "contacts.contact_phone"(newVal, oldVal) {
      if (this.canUpdateFilters(newVal, oldVal, !this.allRecords)) {
        this.$store.commit('PS_SET_CONTACT_PHONE', newVal);
        this.filter();
      }
    },
  },
  async created() {
    await this.getMyData();
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
.sidbar {
  .sidbar-box {
    .md-list-item-container:hover {
      background-color: #3e4345 !important;
    }

    .md-list-item-content {
      justify-content: center;
      flex-direction: column-reverse;
      &:hover,
      &:active {
        background-color: #3e4345 !important;
        .md-icon {
          color: #3b7ef1 !important;
          svg {
            fill: #3b7ef1 !important;
          }
        }
      }

      .md-icon {
        color: white !important;
        margin: 0 !important;
        svg {
          fill: white !important;
          &:hover,
          &:active {
            fill: #3b7ef1 !important;
          }
        }
      }
      p {
        color: white;
        font-size: 12px;
        text-align: center;
        line-height: 1.5;
      }
    }
  }
}

.checklistWpr>.checklist>li>label,
.search_panel>.filter_list{
  cursor: pointer !important 
}
</style>

